import { tabs } from '../../../../../../views/dashboard/service-provider';

export default {
  tabs: {
    [tabs.general]: 'Général',
    [tabs.restaurant_details]: 'Détails du restaurant',
    [tabs.order_conversion]: 'Conversion des commandes',
    [tabs.external_delivery]: 'Livraison externe',
    [tabs.mobile_app]: 'Application mobile',
    [tabs.customer_success_team]: 'Équipe succès client',
    [tabs.onboarding_team]: 'Équipe onboarding',
  },
  date_range: {
    this_month: 'Ce mois-ci',
    last_month: 'Le mois dernier',
    last_week: 'La semaine dernière',
    last_year: "L'année dernière",
    this_week: 'Cette semaine',
    this_year: 'Cette année',
    today: "Aujourd'hui",
    yesterday: 'Hier',
    all: 'Tout',
  },
};
